import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';

import moment from 'moment';

import './style.scss';
import { getAuthData } from '@common/helpers/auth';

const getConfirmationCode = (docNumber) => {
  if (!docNumber) return '';

  return docNumber.toString().slice(-3);
};

const DigitalCashout = ({
  documentNumber,
  date,
  terminalName,
  cashoutAmount,
}) => {
  const t = useTranslation();
  const { tid, currency } = getAuthData()
  const [{ closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small digital-cashout-popup">
      <i onClick={closePopup} className="global-icon icon-Close close-popup" />

      <div className="digital-cashout-header">
        <h3 className="popup-title">{t('Cash Out')}</h3>
        <p className="digital-cashout-subtitle">
          {t('Show the Confirmation Code to the cashier to take your cash out amount')}
        </p>
      </div>

      <div className="digital-cashout-icon">
        <i className="global-icon icon-cashout-money" />
      </div>

      <div className="digital-cashout-document-row">
        <span className="digital-cashout-document-label">{t('Confirmation Code')}</span>
        <span className="digital-cashout-document-value">{getConfirmationCode(documentNumber)}</span>
      </div>

      <div className="digital-cashout-info-list">
        <div className="digital-cashout-info-row">
          <span className="digital-cashout-info-label">{t('Date')}</span>
          <span className="digital-cashout-info-value">{moment(date).isValid() ? moment(date).format('DD.MM.YYYY H:mm:ss') : date}</span>
        </div>
        <div className="digital-cashout-info-row">
          <span className="digital-cashout-info-label">{t('Terminal ID')}</span>
          <span className="digital-cashout-info-value">{tid}</span>
        </div>
        <div className="digital-cashout-info-row">
          <span className="digital-cashout-info-label">{t('Terminal Name')}</span>
          <span className="digital-cashout-info-value">{terminalName}</span>
        </div>
        <div className="digital-cashout-info-row">
          <span className="digital-cashout-info-label">{t('Cashout Amount')}</span>
          <span className="digital-cashout-info-value digital-cashout-amount">
            {cashoutAmount} {currency}
          </span>
        </div>
      </div>

      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={closePopup}
        >
          {t('Ok')}
        </button>
      </div>
    </div>
  );
};

DigitalCashout.propTypes = {
  documentNumber: PropTypes.string,
  date: PropTypes.string,
  terminalName: PropTypes.string,
  cashoutAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DigitalCashout;
